import useAppStateStore from "../../store/client/appState";
import { HTTP_STATUS } from "../wv/consts";
import { transformUserAgent } from "../wv/transformUserAgent";

interface ValidationResult {
  status: string;
  message: string;
  availability: string;
}

interface ValidateUserProps {
  userId: string;
  token: string;
}

// !: 클라이언트 사이드에서 BFF API를 통해 유저 유효성 검증하기 위한 함수
export async function validateUser({
  userId,
  token,
}: ValidateUserProps): Promise<{
  validationResult: ValidationResult | null;
  error: { status: number; message: string } | null;
}> {
  const { userAgent } = useAppStateStore.getState();

  try {
    // api route handler(BFF)를 통해 유저 유효성 검증
    const response = await fetch(`/api/validate/user/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": `Bearer ${token}`,
        "User-Agent": transformUserAgent(userAgent),
      },
    });

    if (!response.ok) {
      return {
        validationResult: null,
        error: {
          status: response.status,
          message: `Failed to validate user, status code: ${response.status}`,
        },
      };
    }

    const result = (await response.json()) as ValidationResult;
    return { validationResult: result, error: null };
  } catch (err) {
    return {
      validationResult: null,
      error: {
        status: HTTP_STATUS.INTERNAL_SERVER_ERROR,
        message: `Failed to validate user, error: ${
          (
            err as {
              message: string;
            }
          ).message
        }`,
      },
    };
  }
}
